import {ImageModel, ListModel} from "../common";

export interface ProductRecordModel {
  id: string;
  agent?: string;
  team?: string;
  workflow?: string;
  prompt?: string;
  phoneNumber?: string;
  callTransfer?: string;
  smsAction?: string;
  postCallExtractor?: string;
  realTimeBooking?: string;
  customAction?: string;
  informationExtractor?: string;
  subaccount: string;
  dataModified: string;
  agentAvatar?: ImageModel;
  subaccountAvatar?: ImageModel;
}

export type ProductListModel = ListModel<ProductRecordModel>;

export enum ProductCategoryRecordModel {
  AGENTS = "agents",
  PROMPTS = "prompts",
  AGENT_TEAMS = "agentTeams",
  WORKFLOWS = "workflows",
  PHONE_NUMBERS = "phoneNumbers",
  CALL_TRANSFERS = "callTransfers",
  SMS_ACTIONS = "smsActions",
  POST_CALL_EXTRACTORS = "postCallExtractors",
  REAL_TIME_BOOKING = "realTimeBooking",
  CUSTOM_ACTIONS = "customActions",
  INFORMATION_EXTRACTOR = "informationExtractor",
}
